// Copyright (c) 2005-2023 David Caldwell <david@porkrind.org>
// Copyright (c) 2005-2010 Jim Radford <radford@blackbean.org>

var highscore = require('./highscore'), HighScoreIntervalViewerBrowser=highscore.HighScoreIntervalViewerBrowser;
var lib = require('./lib'), srand=lib.srand;
var score = require('./score'), stats=score.stats, Stat=score.Stat;

class score_game {
  init(title_name, score_div, highscore_div, highscoretabs_div) {
    this.name = title_name;
    this.highscore ||= new HighScoreIntervalViewerBrowser(highscore_div, highscoretabs_div, this.name);
    this.stats = new stats(this.name);
    this.score = new Stat(score_div, "score", this.stats);
  }

  new_game(seed) {
    this.seed = require('./gotd').pick_seed(seed, this.name);
    srand(this.seed);
    this.game_id = Date.now() + Math.random();
    this.stats.start();
    this.stats.set("seed", this.seed);
    this.stats.set("game_id", this.game_id);
    this.score.set(0);
  }

  end_game() {
    this.stats.done(function(play_id,error) {
        if (error) require('./alert').new_text_alert(error);
        else this.highscore.refresh(play_id);
    }.bind(this));
  }
}

module.exports = score_game;
// Copyright (c) 2005-2023 David Caldwell <david@porkrind.org>
// Copyright (c) 2005-2010 Jim Radford <radford@blackbean.org>

var highscore = require('./highscore'), HighScoreIntervalViewerBrowser=highscore.HighScoreIntervalViewerBrowser;
var lib = require('./lib'), srand=lib.srand;
var score = require('./score'), stats=score.stats, Stat=score.Stat;

class score_game {
  init(title_name, score_div, highscore_div, highscoretabs_div) {
    this.name = title_name;
    this.highscore ||= new HighScoreIntervalViewerBrowser(highscore_div, highscoretabs_div, this.name);
    this.stats = new stats(this.name);
    this.score = new Stat(score_div, "score", this.stats);
  }

  new_game(seed) {
    this.seed = require('./gotd').pick_seed(seed, this.name);
    srand(this.seed);
    this.game_id = Date.now() + Math.random();
    this.stats.start();
    this.stats.set("seed", this.seed);
    this.stats.set("game_id", this.game_id);
    this.score.set(0);
  }

  end_game() {
    this.stats.done(function(play_id,error) {
        if (error) require('./alert').new_text_alert(error);
        else this.highscore.refresh(play_id);
    }.bind(this));
  }
}

module.exports = score_game;
